var map = {
	"./1923.png": 904,
	"./1932.png": 905,
	"./Logo_Uni_Trier_typo_neg.svg": 830,
	"./SMH_Logo_SCHWARZ.jpg": 906,
	"./alle-infofenster-schliessen.svg": 831,
	"./alle-ortsfenster-schliessen.svg": 832,
	"./ansichtsmodus.svg": 833,
	"./arrow-down.svg": 834,
	"./arrow-left-2.svg": 835,
	"./arrow-right-2.svg": 836,
	"./arrow-right.svg": 837,
	"./audio.svg": 838,
	"./collapse_down.png": 907,
	"./collapse_right.png": 908,
	"./dfg_logo_schriftzug_blau_foerderung_4c.jpg": 909,
	"./dfg_logo_schriftzug_blau_foerderung_4c.png": 910,
	"./die-reihe-merz-typo.svg": 839,
	"./ebene-hoeher.svg": 840,
	"./ebene-tiefer.svg": 841,
	"./farbe-waehlen.svg": 842,
	"./fenster-fixieren.svg": 843,
	"./film-neu.svg": 844,
	"./film.svg": 845,
	"./first.svg": 846,
	"./first_active.svg": 847,
	"./icons8-connected-50.png": 911,
	"./icons8-connected-filled-50.png": 912,
	"./icons8-pause-24.png": 913,
	"./icons8-play-24.png": 914,
	"./id-card.svg": 848,
	"./kompetenz_logo_2016_neg.svg": 849,
	"./komposition-exportieren.svg": 850,
	"./komposition-loeschen.svg": 851,
	"./komposition-neu.svg": 852,
	"./komposition-speichern-alternativ.svg": 853,
	"./komposition-speichern.svg": 854,
	"./kompositionsmodus.svg": 855,
	"./konfiguration_oeffnen.svg": 856,
	"./konfiguration_speichern.svg": 857,
	"./kurt-merz-schwitters-typo.svg": 858,
	"./kurt-schwitters-typo.svg": 859,
	"./last.svg": 860,
	"./last_active.svg": 861,
	"./lg.ajax-spinner-preloader.gif": 915,
	"./loading.gif": 916,
	"./loud-volume.png": 421,
	"./medien.svg": 862,
	"./merz22.png": 917,
	"./merz23.png": 918,
	"./merz25_dummy.svg": 863,
	"./next.svg": 864,
	"./next_active.svg": 865,
	"./noten.svg": 866,
	"./oeffnen.svg": 867,
	"./personeninfo-anzeigen.svg": 868,
	"./play.svg": 869,
	"./previous.svg": 870,
	"./previous_active.svg": 871,
	"./relation-anzeigen.svg": 872,
	"./relationen-aktiv.svg": 873,
	"./relationen-icon-1-farbe.svg": 874,
	"./relationen-icon-2-farben.svg": 875,
	"./relationen-icon-3-farben.svg": 876,
	"./relationen-icon-4-farben.svg": 877,
	"./relationen-icon-5-farben.svg": 878,
	"./relationen-inaktiv.svg": 879,
	"./relationen-loeschen.svg": 880,
	"./schallplatten.png": 919,
	"./schliessen.svg": 881,
	"./schwitters_hefte_auswahl_RD_web-felder-nr3.svg": 882,
	"./schwitters_hefte_felder.svg": 883,
	"./schwitters_startseite.svg": 884,
	"./seite-vor.svg": 885,
	"./seite-zurueck.svg": 886,
	"./session-importieren.svg": 887,
	"./session-speichern.svg": 888,
	"./sprengel-museum_logo_grau.png": 920,
	"./sprengel_museum_logo_lay.png": 921,
	"./station-erste.svg": 889,
	"./station-letzte.svg": 890,
	"./station-vor.svg": 891,
	"./station-zurueck.svg": 892,
	"./text.svg": 893,
	"./transkriptionen-aktiv.svg": 894,
	"./transkriptionen-inaktiv.svg": 895,
	"./transkriptionen-loeschen.svg": 896,
	"./transskriptionen-anzeigen.svg": 897,
	"./uni-wuppertal_logo_grau.png": 922,
	"./untersuchungsmodus.svg": 898,
	"./user-circle.svg": 899,
	"./user.svg": 900,
	"./vergleichsmodus.svg": 901,
	"./zeitleiste-anzeigen-alternativ.svg": 902,
	"./zeitleiste-anzeigen.svg": 903
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2008;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*$
// module id = 2008
// module chunks = 1